import { Flex, Spinner, Text } from '@bonusly/design-system';

interface LoadingStateProps {
	message?: string;
}

export function LoadingState({ message = 'Loading collaborative editor...' }: LoadingStateProps) {
	return (
		<Flex align="center" justify="center" py={8} data-component="editor-loading-state">
			<Spinner size="lg" />
			<Text ml={4} color="text.softer">
				{message}
			</Text>
		</Flex>
	);
}
